import emailjs from '@emailjs/browser';

const CONFIG = {
  SERVICE_ID: "service_4xurdov",
  TEMPLATES: {
    CLIENT: "template_ygnzorr",
    ADMIN: "template_bfumjkr",
  },
  PUBLIC_KEY: "qFnBMPruoa902ZzsR",
  ADMIN_EMAIL: "lowcountryboys@grupomhpm.com",
  RESTAURANT_INFO: {
    name: 'Low Country Boys',
    address: 'Av. Ntra. Señora del Retamar, 16, 28232 Las Rozas de Madrid, Madrid.',
    phone: '+34 912 37 86 63',
    email: 'lowcountryboys@grupomhpm.com'
  }
};

export const emailService = {
  async sendReservationStatusEmail(reservation, status) {
    try {
      const subject = status === 'RESERVA CONFIRMADA' 
        ? 'Confirmación de Reserva'
        : 'Cancelación de Reserva';

      // Asegurarse de que guests sea un número y tenga un valor por defecto
      const guestsNumber = reservation.guests || 2;

      const clientParams = {
        to_email: reservation.customer.email,
        to_name: `${reservation.customer.firstName} ${reservation.customer.lastName}`,
        subject: subject,
        reservation_date: reservation.date,
        reservation_time: reservation.time,
        reservation_guests: `${guestsNumber} personas`, // Formateado para mostrar "X personas"
        status_message: status === 'RESERVA CONFIRMADA' 
          ? '¡Su reserva ha sido confirmada!' 
          : 'Su reserva ha sido cancelada.',
        restaurant_name: CONFIG.RESTAURANT_INFO.name,
        restaurant_address: CONFIG.RESTAURANT_INFO.address,
        restaurant_phone: CONFIG.RESTAURANT_INFO.phone,
        customer_comments: reservation.customer.comments || 'Sin comentarios adicionales'
      };

      const adminParams = {
        to_email: CONFIG.ADMIN_EMAIL,
        subject: `Reserva ${status === 'RESERVA CONFIRMADA' ? 'Confirmada' : 'Cancelada'}`,
        customer_name: `${reservation.customer.firstName} ${reservation.customer.lastName}`,
        customer_email: reservation.customer.email,
        customer_phone: reservation.customer.phone,
        reservation_date: reservation.date,
        reservation_time: reservation.time,
        reservation_guests: `${guestsNumber} personas`, // Formateado para mostrar "X personas"
        status: status,
        customer_comments: reservation.customer.comments || 'Sin comentarios adicionales'
      };

      // Enviar ambos emails en paralelo
      const [clientResponse, adminResponse] = await Promise.all([
        emailjs.send(CONFIG.SERVICE_ID, CONFIG.TEMPLATES.CLIENT, clientParams, CONFIG.PUBLIC_KEY),
        emailjs.send(CONFIG.SERVICE_ID, CONFIG.TEMPLATES.ADMIN, adminParams, CONFIG.PUBLIC_KEY)
      ]);

      return { clientResponse, adminResponse };
    } catch (error) {
      console.error('Error enviando emails:', error);
      throw error;
    }
  },
  async sendSpecialReservationEmail(reservation, type) {
    try {
      // Determinar el tipo de solicitud para personalizar el mensaje
      const isWaitlist = type === 'waitlist';
      const subject = isWaitlist 
        ? 'Solicitud de Lista de Espera - Low Country Boys'
        : 'Solicitud de Reserva de Grupo - Low Country Boys';
      
      const messageType = isWaitlist ? 'Lista de Espera' : 'Reserva de Grupo';
      const specialMessage = isWaitlist
        ? 'Su solicitud para entrar en la lista de espera ha sido recibida.'
        : 'Su solicitud de reserva para grupo ha sido recibida.';

      // Parámetros para el email al cliente
      const clientParams = {
        to_email: reservation.customer.email,
        to_name: `${reservation.customer.firstName} ${reservation.customer.lastName}`,
        subject: subject,
        reservation_date: reservation.date,
        reservation_time: reservation.time || 'Pendiente de confirmar',
        reservation_guests: `${reservation.guests} personas`,
        status_message: 'Su solicitud será revisada por nuestro equipo. Si hay algún inconveniente nos pondremos en contacto con usted. De lo contrario, recibirá un email de confirmación en cuanto su solicitud sea procesada.',
        restaurant_name: CONFIG.RESTAURANT_INFO.name,
        restaurant_address: CONFIG.RESTAURANT_INFO.address,
        restaurant_phone: CONFIG.RESTAURANT_INFO.phone
      };

      // Parámetros para el email al administrador
      const adminParams = {
        to_email: CONFIG.ADMIN_EMAIL,
        subject: `Nueva Solicitud - ${messageType}`,
        customer_name: `${reservation.customer.firstName} ${reservation.customer.lastName}`,
        customer_email: reservation.customer.email,
        customer_phone: reservation.customer.phone,
        reservation_date: reservation.date,
        reservation_time: reservation.time || 'Pendiente de confirmar',
        reservation_guests: `${reservation.guests} personas`,
        request_type: messageType,
        status: 'PENDIENTE DE GESTION',
        comments: reservation.customer.comments || 'Sin comentarios adicionales'
      };

      // Enviar ambos emails en paralelo
      const [clientResponse, adminResponse] = await Promise.all([
        emailjs.send(CONFIG.SERVICE_ID, CONFIG.TEMPLATES.CLIENT, clientParams, CONFIG.PUBLIC_KEY),
        emailjs.send(CONFIG.SERVICE_ID, CONFIG.TEMPLATES.ADMIN, adminParams, CONFIG.PUBLIC_KEY)
      ]);

      return { clientResponse, adminResponse };
    } catch (error) {
      console.error('Error enviando emails de solicitud especial:', error);
      throw error;
    }
  }
};